export default {
  mainTitle: { id: 'environment_monitor' },
  siteList: { id: 'site_list' },
  oxygen: { id: 'oxygen' },
  temperature: { id: 'temperature' },
  speed: { id: 'speed' },
  tide: { id: 'tide' },
  viewType: { id: 'view_type' },
  hourForecast: { id: 'hour_forecast' },
  hour: { id: 'hour' },
  today: { id: 'today' },
  yesterday: { id: 'yesterday' },
  tomorrow: { id: 'tomorrow' },
  forecastChart: { id: 'forecast_chart' },
  historicalChart: { id: 'historical_chart' },
  last: { id: 'last' },
  details: { id: 'details' },
  forecast: { id: 'forecast' },
  lastDetails: { id: 'last_details' },
  lastHours: { id: 'last_hours' },
  meters: { id: 'meters' },
  saturation: { id: 'saturation' },
  transparency: { id: 'transparency' },
  cloudCover: { id: 'cloud_cover' },
  typeFilter: { id: 'type_filter' },
  pew: { id: 'pew' },
  confidenceInterval: { id: 'confidence_interval' },
  days: { id: 'days' },
  viewHistory: { id: 'view_history' },
  viewForecast: { id: 'view_forecast' },
  min: { id: 'min' },
  max: { id: 'max' },
  avg: { id: 'avg' },
  std: { id: 'std' },
}
